<template>
  <Catalogs
    title="Должности"
    create-text="Новая"
    :fetch-data="fetchData"
    :route-create="'JobTitleAdd'"
    :route-edit="'JobTitleEdit'"
    :route-view="'JobTitleView'"
    :route-path="'/job_titles'"
    :can-edit="canEditJobTitleCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "JobTitles",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getJobTitles(data);
    },
    canEditJobTitleCatalogs() {
      return this.hasPermission([PERM.CATALOG_JOB_TITLE_EDIT]);
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Catalogs/JobTitles/JobTitles.vue